;(function () {

"use strict";

function resize() {
  var max = -1000;
  var $addresses = $('.addresses > li.address');

  $addresses.each(function () {
    var h = $(this).css('height', '').height();
    if (h > max) {
      max = h;
    }
  });

  $addresses.height(max);
}

function openSmileWidget() {
  if (window.SmileUI) {
    SmileUI.openPanel();
  } else {
    setTimeout(function() { openSmileWidget() }, 100);
  }
}

var PageView = Backbone.View.extend({
  initialize: function () {
    var $toggle = $('#newsletter-enabled');
    var email = $toggle.data('email');
    var url = '//dev.roseandrex.com/subscribed/'+email;
    var accepts_marketing = $toggle.prop('checked');

    $.get(url, function (d) {
      if (d.subscribed != accepts_marketing && !accepts_marketing) {
        // console.log('OUT OF SYNC');
        // console.log(d.subscribed);
        // console.log(accepts_marketing);

        $toggle.trigger('click');
      }
    });

    var ww = $(window).width();
    if (ww >= 640) {
      openSmileWidget();
    }

    $(window).on('resize', resize);
    resize();
  },
  updateSubscriptionSettings: function (e) {
    // console.log('updating settings');
    var $this = $(e.currentTarget);
    var accepts_marketing = $this.prop('checked');
    var id = $this.data('id');
    var email = $this.data('email');
    var fname = $this.data('fname');
    var lname = $this.data('lname');

    /* post to dev shopify */
    var url = "//dev.roseandrex.com/update-settings";
    // var url = "http://localhost:3000/update-settings";

    $.post(url, {accepts_marketing: accepts_marketing, id: id, email: email, fname: fname, lname: lname}, _.bind(function (d) {
      // console.log('posted to newsletter');
      // console.log(d);
    }, this));

  },
  events: {
    'change #newsletter-enabled': 'updateSubscriptionSettings'
  }
});

module.exports = PageView;

}());